import React, { useState } from 'react';
import { length } from 'ramda';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';

import PrimaryButton from '../../components/PrimaryButton';
import Checkbox from '../../components/Checkbox';

const handleInputChange = (setTan, setLoading, history) => e => {
    e.persist();

    const tan = e.target.value;

    setTan(tan);

    if(length(tan) === 6) {
        setLoading(true);
        
        const checkTan = firebase
            .functions()
            .httpsCallable('checkTan');
        
        firebase.database().ref(`/users/${firebase.auth().currentUser.uid}`).once('value')
            .then(snapshot => snapshot.val().phone)
            .then(phone => checkTan({
                phone,
                tan,
            }))
            .then(() => history.push('/dashboard/signature'))
            .then(() => setLoading(false));
    }
}

function TAN({ history }) {
    const [ tan, setTan ] = useState('');
    const [ loading, setLoading ] = useState(false)

    return (
        <div className='modal'>
            <form className='modal__content' onSubmit={() => history.push('/dashboard/tan')}>
                <div className='modal__title'>
                    <h2>TAN eingeben</h2>
                </div>
                <div className='modal__body'>
                    <p>
                        Bitte geben Sie die Registrierungs-TAN ein, die Sie per SMS erhalten haben.
                    </p>
                    <div className='tan'>
                        <input
                            autoFocus
                            disabled={loading}
                            type="tel"
                            pattern="[0-9 ]*"
                            className='tan__field'
                            maxlength='6'
                            onChange={handleInputChange(setTan, setLoading, history)}
                        />
                        {loading && (
                            <div class="lds-ring lds-ring--blue lds-ring--small"><div></div><div></div><div></div><div></div></div>
                        )}
                    </div>
                </div>
                <div class='modal__footer'>
                    <PrimaryButton
                        title='TAN erneut versenden'
                        disabled
                    />
                </div>
            </form>
        </div>
    )
}

export default TAN;
